import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import EmployeeDetailPage from './pages/EmployeeDetailPage';
import EmployeeListPage from './pages/EmployeeListPage';

export const corporateEmployeeModule: ModuleDefinition = {
  routes: [
    { path: 'corporate/employees', element: <EmployeeListPage /> },
    { path: 'corporate/employees/:employeeId', element: <EmployeeDetailPage /> },
  ],
  menuItems: [
    {
      label: 'Personel',
      path: 'corporate/employees',
      icon: <BadgeOutlinedIcon />,
      group: 'Kurumsal',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
